import React from 'react'
import PropTypes from 'prop-types'
import { Map, List } from 'immutable'
import InvoiceTableRow from '@aytm/lib/rfd-ui/components/payment/invoice-table/row'
import InvoiceTableTextRow from '@aytm/lib/rfd-ui/components/payment/invoice-table/text'
import Select from '@aytm/lib/rfd-ui/components/basic/select'

export default class InvoiceTableSelectRow extends InvoiceTableRow {
  static propTypes = {
    row: PropTypes.instanceOf(Map).isRequired,
    updateData: PropTypes.instanceOf(Map).isRequired,
    width: PropTypes.number,
    valuesWidth: PropTypes.number,
    onChange: PropTypes.func,
    onOverflow: PropTypes.func
  }

  constructor(...args) {
    super(...args);
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(option) {
    const { onChange, row } = this.props
    const id = row.get('id')

    if (id && 'function' == typeof onChange) {
      onChange(
        Map({
          [id]: Map({
            type: 'select',
            value: Map({
              id: option.get('value')
            })
          })
        }),
        id,
        false !== row.get('update')
      )
    }
    return false
  }

  renderSelector() {
    const { row, width, updateData, onOverflow } = this.props
    const options = row.get('options') || List()
    const id = row.get('id')
    const value = updateData.hasIn([id, 'value', 'id']) ? updateData.getIn([id, 'value', 'id']) : row.get('select')

    return (
      <Select
        width={width}
        options={options}
        value={value}
        placeholder={row.get('placeholder')}
        onSelect={this.onSelect}
        onOverflow={onOverflow}
        error={row.get('error')}
        showSelected={row.get('showselected')}
        isEmpty={true}
      />
    )
  }

  render() {
    const { row, width, valuesWidth } = this.props

    return (
      <div className="rfd-ui-invoice-table-row-container">
        {row.has('text') && <InvoiceTableTextRow row={row} width={width} valuesWidth={valuesWidth} />}
        {this.renderSelector()}
        {row.has('note') && (
          <div className="rfd-ui-invoice-table-row-value" style={{ width: valuesWidth }}>
            <div
              className="rfd-ui-invoice-table-row-value-text"
              dangerouslySetInnerHTML={{ __html: this.preprocessText(row.get('note')) }}
            />
          </div>
        )}
      </div>
    )
  }
}
